<template lang="pug">
    v-col(cols='12' md='12' v-if="validIncomingPhoneNumber")
        v-alert(
            elevation="2"
            style="padding-top: 0; padding-bottom: 0; margin-bottom: 8px;"
        )
            v-container
                BandwidthDevice(
                    v-if="incomingPhoneNumberProvider === 'volie_voice'"
                    :audio-phone-device-connect="audioPhoneDeviceConnect"
                    :audio-phone-device-dtmf0="audioPhoneDeviceDtmf0"
                    :audio-phone-device-dtmf1="audioPhoneDeviceDtmf1"
                    :audio-phone-device-dtmf2="audioPhoneDeviceDtmf2"
                    :audio-phone-device-dtmf3="audioPhoneDeviceDtmf3"
                    :audio-phone-device-dtmf4="audioPhoneDeviceDtmf4"
                    :audio-phone-device-dtmf5="audioPhoneDeviceDtmf5"
                    :audio-phone-device-dtmf6="audioPhoneDeviceDtmf6"
                    :audio-phone-device-dtmf7="audioPhoneDeviceDtmf7"
                    :audio-phone-device-dtmf8="audioPhoneDeviceDtmf8"
                    :audio-phone-device-dtmf9="audioPhoneDeviceDtmf9"
                    :audio-phone-device-dtmf-hash="audioPhoneDeviceDtmfHash"
                    :audio-phone-device-dtmf-star="audioPhoneDeviceDtmfStar"
                    :audio-phone-device-disconnect="audioPhoneDeviceDisconnect"
                    :audio-phone-device-ringing="audioPhoneDeviceRinging"
                    :call-failed="callFailed"
                    :communication-manager="communicationManager"
                    :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
                    :create-agent="createAgent"
                    :current-campaign-customer="currentCampaignCustomer"
                    :enter-manual-mode="enterManualMode"
                    :exit-manual-mode="exitManualMode"
                    :force-call="forceCall"
                    :force-conference="forceConference"
                    :force-end-call="forceEndCall"
                    :force-start-next-dial="forceStartNextDial"
                    :force-transfer-dialog="forceTransferDialog"
                    :force-web-rtc-participant="forceWebRtcParticipant"
                    :force-web-rtc-session="forceWebRtcSession"
                    :has-logged-in-queues="hasLoggedInQueues"
                    :on-vin-login-decision-required="onVinLoginDecisionRequired"
                    :incoming-phone-number="incomingPhoneNumber"
                    :is-manual-mode="isManualMode"
                    :is-okay-to-save-and-next="isOkayToSaveAndNext"
                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                    :is-wrap-up-blocking-dial="isWrapUpBlockingDial"
                    :missed-call-from-call-screen="missedCallFromCallScreen"
                    :organization-users="organizationUsers"
                    :remove-force-transfer-dialog="removeForceTransferDialog"
                    :retry-dial-intent-token="retryDialIntentToken"
                    :save-and-next-action="saveAndNextAction"
                    :clear-dial-intent="clearDialIntent"
                    :selected-campaign-disposition="selectedCampaignDisposition"
                    :set-call="setCall"
                    :set-call-failed="setCallFailed"
                    :set-on-call="setOnCall"
                    :should-skip-wrap-up-for-get-next-advance="shouldSkipWrapUpForGetNextAdvance"
                    :start-save-and-next="startSaveAndNext"
                    :voice-mail-recording="voiceMailRecording"
                    :pending-saved-place-call="pendingSavedPlaceCall"
                    :vin-login-decision-pending="vinLoginDecisionPending"
                )

                TelnyxDevice(
                    v-if="incomingPhoneNumberProvider === 'telnyx'"
                    :audio-phone-device-connect="audioPhoneDeviceConnect"
                    :audio-phone-device-dtmf0="audioPhoneDeviceDtmf0"
                    :audio-phone-device-dtmf1="audioPhoneDeviceDtmf1"
                    :audio-phone-device-dtmf2="audioPhoneDeviceDtmf2"
                    :audio-phone-device-dtmf3="audioPhoneDeviceDtmf3"
                    :audio-phone-device-dtmf4="audioPhoneDeviceDtmf4"
                    :audio-phone-device-dtmf5="audioPhoneDeviceDtmf5"
                    :audio-phone-device-dtmf6="audioPhoneDeviceDtmf6"
                    :audio-phone-device-dtmf7="audioPhoneDeviceDtmf7"
                    :audio-phone-device-dtmf8="audioPhoneDeviceDtmf8"
                    :audio-phone-device-dtmf9="audioPhoneDeviceDtmf9"
                    :audio-phone-device-dtmf-hash="audioPhoneDeviceDtmfHash"
                    :audio-phone-device-dtmf-star="audioPhoneDeviceDtmfStar"
                    :audio-phone-device-disconnect="audioPhoneDeviceDisconnect"
                    :audio-phone-device-ringing="audioPhoneDeviceRinging"
                    :call-failed="callFailed"
                    :communication-manager="communicationManager"
                    :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
                    :create-agent="createAgent"
                    :current-campaign-customer="currentCampaignCustomer"
                    :enter-manual-mode="enterManualMode"
                    :exit-manual-mode="exitManualMode"
                    :force-call="forceCall"
                    :force-conference="forceConference"
                    :force-end-call="forceEndCall"
                    :force-start-next-dial="forceStartNextDial"
                    :force-transfer-dialog="forceTransferDialog"
                    :force-web-rtc-participant="forceWebRtcParticipant"
                    :force-web-rtc-session="forceWebRtcSession"
                    :has-logged-in-queues="hasLoggedInQueues"
                    :on-vin-login-decision-required="onVinLoginDecisionRequired"
                    :incoming-phone-number="incomingPhoneNumber"
                    :is-barge="isBarge"
                    :is-coach="isCoach"
                    :is-listen="isListen"
                    :is-live-dash-inbound-call="isLiveDashInboundCall"
                    :is-manual-mode="isManualMode"
                    :is-okay-to-save-and-next="isOkayToSaveAndNext"
                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                    :is-wrap-up-blocking-dial="isWrapUpBlockingDial"
                    :missed-call-from-call-screen="missedCallFromCallScreen"
                    :organization-users="organizationUsers"
                    :remove-force-transfer-dialog="removeForceTransferDialog"
                    :retry-dial-intent-token="retryDialIntentToken"
                    :save-and-next-action="saveAndNextAction"
                    :clear-dial-intent="clearDialIntent"
                    :selected-campaign-disposition="selectedCampaignDisposition"
                    :set-call="setCall"
                    :set-call-failed="setCallFailed"
                    :set-on-call="setOnCall"
                    :should-skip-wrap-up-for-get-next-advance="shouldSkipWrapUpForGetNextAdvance"
                    :start-save-and-next="startSaveAndNext"
                    :voice-mail-recording="voiceMailRecording"
                    :pending-saved-place-call="pendingSavedPlaceCall"
                    :toggle-freeze-agent-status-push="toggleFreezeAgentStatusPush"
                    :freeze-agent-status-push="freezeAgentStatusPush"
                    :force-validated-outbound-number="forceValidatedOutboundNumber"
                    :vin-login-decision-pending="vinLoginDecisionPending"
                )

                TwilioDevice(
                    v-if="incomingPhoneNumberProvider === 'twilio'"
                    :call-failed="callFailed"
                    :communication-manager="communicationManager"
                    :complete-attempt-for-internal-transfer="completeAttemptForInternalTransfer"
                    :create-agent="createAgent"
                    :current-campaign-customer="currentCampaignCustomer"
                    :enter-manual-mode="enterManualMode"
                    :exit-manual-mode="exitManualMode"
                    :force-call="forceCall"
                    :force-conference="forceConference"
                    :force-end-call="forceEndCall"
                    :force-start-next-dial="forceStartNextDial"
                    :force-transfer-dialog="forceTransferDialog"
                    :has-logged-in-queues="hasLoggedInQueues"
                    :on-vin-login-decision-required="onVinLoginDecisionRequired"
                    :incoming-phone-number="incomingPhoneNumber"
                    :is-barge="isBarge"
                    :is-listen="isListen"
                    :is-live-dash-inbound-call="isLiveDashInboundCall"
                    :is-manual-mode="isManualMode"
                    :is-okay-to-save-and-next="isOkayToSaveAndNext"
                    :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                    :is-wrap-up-blocking-dial="isWrapUpBlockingDial"
                    :force-is-non-browser-device="isNonBrowserDevice"
                    :organization-users="organizationUsers"
                    :missed-call-from-call-screen="missedCallFromCallScreen"
                    :remove-force-transfer-dialog="removeForceTransferDialog"
                    :retry-dial-intent-token="retryDialIntentToken"
                    :save-and-next-action="saveAndNextAction"
                    :clear-dial-intent="clearDialIntent"
                    :selected-campaign-disposition="selectedCampaignDisposition"
                    :set-call="setCall"
                    :set-call-failed="setCallFailed"
                    :set-on-call="setOnCall"
                    :should-skip-wrap-up-for-get-next-advance="shouldSkipWrapUpForGetNextAdvance"
                    :start-save-and-next="startSaveAndNext"
                    :voice-mail-recording="voiceMailRecording"
                    :pending-saved-place-call="pendingSavedPlaceCall"
                    :toggle-freeze-agent-status-push="toggleFreezeAgentStatusPush"
                    :freeze-agent-status-push="freezeAgentStatusPush"
                    :force-validated-outbound-number="forceValidatedOutboundNumber"
                    :vin-login-decision-pending="vinLoginDecisionPending"
                )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Components
    import BandwidthDevice from '@/components/communication_center/phone/bandwidth/device.vue';
    import TelnyxDevice from '@/components/communication_center/phone/telnyx/device.vue';
    import TwilioDevice from '@/components/communication_center/phone/twilio/device.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
        },
        computed: {
            incomingPhoneNumberProvider() {
                return this.validIncomingPhoneNumber && this.incomingPhoneNumber?.provider;
            },
            validIncomingPhoneNumber() {
                return this.incomingPhoneNumber?.incoming_phone_number_id > 0;
            },
        },
        components: {
            BandwidthDevice,
            TelnyxDevice,
            TwilioDevice,
        },
        props: {
            audioPhoneDeviceConnect: HTMLAudioElement,
            audioPhoneDeviceDtmf0: HTMLAudioElement,
            audioPhoneDeviceDtmf1: HTMLAudioElement,
            audioPhoneDeviceDtmf2: HTMLAudioElement,
            audioPhoneDeviceDtmf3: HTMLAudioElement,
            audioPhoneDeviceDtmf4: HTMLAudioElement,
            audioPhoneDeviceDtmf5: HTMLAudioElement,
            audioPhoneDeviceDtmf6: HTMLAudioElement,
            audioPhoneDeviceDtmf7: HTMLAudioElement,
            audioPhoneDeviceDtmf8: HTMLAudioElement,
            audioPhoneDeviceDtmf9: HTMLAudioElement,
            audioPhoneDeviceDtmfHash: HTMLAudioElement,
            audioPhoneDeviceDtmfStar: HTMLAudioElement,
            audioPhoneDeviceDisconnect: HTMLAudioElement,
            audioPhoneDeviceRinging: HTMLAudioElement,
            callFailed: Boolean,
            clearDialIntent: Function,
            communicationManager: Object,
            completeAttemptForInternalTransfer: Function,
            createAgent: Function,
            currentCampaignCustomer: Object,
            enterManualMode: Function,
            exitManualMode: Function,
            forceCall: Object,
            forceConference: Object,
            forceEndCall: Boolean,
            forceStartNextDial: Boolean,
            forceTransferDialog: Object,
            forceWebRtcParticipant: Object,
            forceWebRtcSession: Object,
            hasLoggedInQueues: Boolean,
            onVinLoginDecisionRequired: Function,
            incomingPhoneNumber: Object,
            isBarge: Boolean,
            isCoach: Boolean,
            isListen: Boolean,
            isLiveDashInboundCall: Boolean,
            isManualMode: Boolean,
            isNonBrowserDevice: Boolean,
            isOkayToSaveAndNext: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isWrapUpBlockingDial: Boolean,
            missedCallFromCallScreen: Boolean,
            organizationUsers: Array,
            pendingSavedPlaceCall: Object,
            removeForceTransferDialog: Function,
            retryDialIntentToken: Number,
            saveAndNextAction: String,
            selectedCampaignDisposition: Object,
            setCall: Function,
            setCallFailed: Function,
            setOnCall: Function,
            shouldSkipWrapUpForGetNextAdvance: Function,
            startSaveAndNext: Function,
            voiceMailRecording: Object,
            toggleFreezeAgentStatusPush: Function,
            freezeAgentStatusPush: Boolean,
            forceValidatedOutboundNumber: String,
            vinLoginDecisionPending: Boolean,
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .padding-xs {
            padding: 6px 0 6px 0;
        }

        .btn-margin-xs {
            margin: 4px 4px 4px 4px !important;
        }
    }
</style>
